// extracted by mini-css-extract-plugin
export default {"storyDetailAdvertAvatar":"c-r_hm","storyDetailAdvertAvatar__image":"c-r_hn"};